<template>
  <modal :show.sync="modals.modal1" footerClasses="text-right" :largeModal="true">
    <h6
      slot="header"
      class="modal-title text-success font-weight-bold"
      id="modal-title-default"
    >SOP Sistem Informasi Pajak Daerah</h6>
    <div class="d-block" style="overflow-x: auto;
	white-space: nowrap;">
      <div class="row">
        <div class="col-lg-12 col-sm-12">
          <table border=0 cellpadding=0 cellspacing=0 width=1324 style='border-collapse:
 collapse;table-layout:fixed;width:995pt'>
 <col class=xl104 width=32 style='mso-width-source:userset;mso-width-alt:1170;
 width:24pt'>
 <col class=xl104 width=196 style='mso-width-source:userset;mso-width-alt:7168;
 width:147pt'>
 <col class=xl104 width=90 style='mso-width-source:userset;mso-width-alt:3291;
 width:68pt'>
 <col class=xl104 width=89 style='mso-width-source:userset;mso-width-alt:3254;
 width:67pt'>
 <col class=xl104 width=102 style='mso-width-source:userset;mso-width-alt:3730;
 width:77pt'>
 <col class=xl104 width=88 style='mso-width-source:userset;mso-width-alt:3218;
 width:66pt'>
 <col class=xl104 width=106 style='mso-width-source:userset;mso-width-alt:3876;
 width:80pt'>
 <col class=xl104 width=105 style='mso-width-source:userset;mso-width-alt:3840;
 width:79pt'>
 <col class=xl104 width=178 style='mso-width-source:userset;mso-width-alt:6509;
 width:134pt'>
 <col class=xl104 width=83 style='mso-width-source:userset;mso-width-alt:3035;
 width:62pt'>
 <col class=xl104 width=136 style='mso-width-source:userset;mso-width-alt:4973;
 width:102pt'>
 <col class=xl104 width=119 style='mso-width-source:userset;mso-width-alt:4352;
 width:89pt'>
 <col class=xl104 width=14 style='mso-width-source:userset;mso-width-alt:512;
 width:11pt'>
 <tr class=xl104 height=22 style='height:16.5pt'>
  <td height=22 class=xl102 colspan=5 width=509 style='height:16.5pt;
  mso-ignore:colspan;width:383pt'><a name="Print_Area">Prosedur Pendaftaran
  Objek Baru Pajak Bumi dan Bangunan</a></td>
  <td class=xl103 width=88 style='width:66pt'></td>
  <td class=xl103 width=106 style='width:80pt'></td>
  <td class=xl103 width=105 style='width:79pt'></td>
  <td class=xl103 width=178 style='width:134pt'></td>
  <td class=xl103 width=83 style='width:62pt'></td>
  <td class=xl103 width=136 style='width:102pt'></td>
  <td class=xl103 width=119 style='width:89pt'></td>
 </tr>
 <tr height=20 style='height:15.0pt'>
  <td height=20 class=xl104 style='height:15.0pt'></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
 </tr>
 <tr height=28 style='mso-height-source:userset;height:21.0pt'>
  <td rowspan=3 height=128 class=xl314 style='border-bottom:.5pt solid black;
  height:96.0pt'>No</td>
  <td rowspan=3 class=xl107 style='border-bottom:.5pt solid black'>Uraian</td>
  <td colspan=6 class=xl118 style='border-left:none'>Pelaksana</td>
  <td colspan=3 class=xl317 style='border-right:.5pt solid black;border-left:
  none'>Mutu Baku</td>
  <td rowspan=3 class=xl107 style='border-bottom:.5pt solid black'>Ket</td>
 </tr>
 <tr height=20 style='mso-height-source:userset;height:15.0pt'>
  <td rowspan=2 height=100 class=xl306 width=90 style='border-bottom:.5pt solid black;
  height:75.0pt;border-top:none;width:68pt'>Kepala Badan</td>
  <td rowspan=2 class=xl305 style='border-bottom:.5pt solid black'>Sekretaris</td>
  <td rowspan=2 class=xl306 width=102 style='border-bottom:.5pt solid black;
  border-top:none;width:77pt'>Kepala Bidang PBB dan BPHTB</td>
  <td rowspan=2 class=xl308 width=88 style='border-bottom:.5pt solid black;
  width:66pt'>Kepala Sub Bidang Pendaftaran, Pendataan, dan Penilaian</td>
  <td rowspan=2 class=xl308 width=106 style='border-bottom:.5pt solid black;
  width:80pt'>Jabatan Fungsional Umum</td>
  <td rowspan=2 class=xl305 style='border-bottom:.5pt solid black'>Wajib Pajak</td>
  <td rowspan=2 class=xl107 style='border-bottom:.5pt solid black;border-top:
  none'>Persyaratan/Kelengkapan</td>
  <td rowspan=2 class=xl107 style='border-bottom:.5pt solid black;border-top:
  none'>Waktu</td>
  <td rowspan=2 class=xl309 style='border-bottom:.5pt solid black;border-top:
  none'>Output</td>
 </tr>
 <tr height=80 style='mso-height-source:userset;height:60.0pt'>
 </tr>
 <tr height=162 style='mso-height-source:userset;height:121.5pt'>
  <td rowspan=2 height=211 class=xl107 style='border-bottom:.5pt solid black;
  height:158.25pt;border-top:none'>1</td>
  <td rowspan=2 class=xl105 width=196 style='border-bottom:.5pt solid black;
  border-top:none;width:147pt'>Wajib Pajak (WP) mengambil dan mengisi formulir
  Surat Pemberitahuan Objek Pajak (SPOP) beserta lampiran Surat Pemberitahuan
  Objek Pajak (LSPOP), kemudian diserahkan kepada Petugas Pelayanan.</td>
  <td align=left valign=top><!--[if gte vml 1]><v:shapetype id="_x0000_t75"
   coordsize="21600,21600" o:spt="75" o:preferrelative="t" path="m@4@5l@4@11@9@11@9@5xe"
   filled="f" stroked="f">
   <v:stroke joinstyle="miter"/>
   <v:formulas>
    <v:f eqn="if lineDrawn pixelLineWidth 0"/>
    <v:f eqn="sum @0 1 0"/>
    <v:f eqn="sum 0 0 @1"/>
    <v:f eqn="prod @2 1 2"/>
    <v:f eqn="prod @3 21600 pixelWidth"/>
    <v:f eqn="prod @3 21600 pixelHeight"/>
    <v:f eqn="sum @0 0 1"/>
    <v:f eqn="prod @6 1 2"/>
    <v:f eqn="prod @7 21600 pixelWidth"/>
    <v:f eqn="sum @8 21600 0"/>
    <v:f eqn="prod @7 21600 pixelHeight"/>
    <v:f eqn="sum @10 21600 0"/>
   </v:formulas>
   <v:path o:extrusionok="f" gradientshapeok="t" o:connecttype="rect"/>
   <o:lock v:ext="edit" aspectratio="t"/>
  </v:shapetype><v:shape id="Rectangle_x0020_1" o:spid="_x0000_s2049" type="#_x0000_t75"
   style='position:absolute;margin-left:300.75pt;margin-top:557.25pt;width:39pt;
   height:21pt;z-index:1;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image004.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Straight_x0020_Arrow_x0020_Connector_x0020_2" o:spid="_x0000_s2050"
   type="#_x0000_t75" style='position:absolute;margin-left:314.25pt;
   margin-top:201.75pt;width:9.75pt;height:78pt;z-index:2;visibility:visible'
   o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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==
">
   <v:imagedata src="image005.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Diamond_x0020_3" o:spid="_x0000_s2051" type="#_x0000_t75"
   style='position:absolute;margin-left:297pt;margin-top:176.25pt;width:45.75pt;
   height:26.25pt;z-index:3;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image006.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Rectangle_x0020_4" o:spid="_x0000_s2052" type="#_x0000_t75"
   style='position:absolute;margin-left:225pt;margin-top:734.25pt;width:38.25pt;
   height:21pt;z-index:4;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image007.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Shape_x0020_5" o:spid="_x0000_s2053" type="#_x0000_t75"
   style='position:absolute;margin-left:315pt;margin-top:41.25pt;width:55.5pt;
   height:141pt;z-index:5;visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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=
">
   <v:imagedata src="image008.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Shape_x0020_6" o:spid="_x0000_s2054" type="#_x0000_t75"
   style='position:absolute;margin-left:342pt;margin-top:48.75pt;width:59.25pt;
   height:141.75pt;z-index:6;visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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=
">
   <v:imagedata src="image009.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Shape_x0020_7" o:spid="_x0000_s2055" type="#_x0000_t75"
   style='position:absolute;margin-left:239.25pt;margin-top:567pt;width:62.25pt;
   height:172.5pt;z-index:7;visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image010.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Rectangle_x0020_8" o:spid="_x0000_s2056" type="#_x0000_t75"
   style='position:absolute;margin-left:300pt;margin-top:273.75pt;width:39pt;
   height:21pt;z-index:8;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image007.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Rectangle_x0020_9" o:spid="_x0000_s2057" type="#_x0000_t75"
   style='position:absolute;margin-left:153.75pt;margin-top:421.5pt;width:38.25pt;
   height:21pt;z-index:9;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image007.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Rectangle_x0020_10" o:spid="_x0000_s2058" type="#_x0000_t75"
   style='position:absolute;margin-left:300pt;margin-top:345.75pt;width:39pt;
   height:21pt;z-index:10;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image007.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Straight_x0020_Arrow_x0020_Connector_x0020_11" o:spid="_x0000_s2059"
   type="#_x0000_t75" style='position:absolute;margin-left:314.25pt;
   margin-top:294.75pt;width:9.75pt;height:55.5pt;z-index:11;visibility:visible'
   o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image011.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Elbow_x0020_Connector_x0020_13" o:spid="_x0000_s2060"
   type="#_x0000_t75" style='position:absolute;margin-left:168pt;margin-top:355.5pt;
   width:132.75pt;height:71.25pt;z-index:12;visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image012.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Rectangle_x0020_13" o:spid="_x0000_s2061" type="#_x0000_t75"
   style='position:absolute;margin-left:223.5pt;margin-top:421.5pt;width:39pt;
   height:21pt;z-index:13;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image004.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Straight_x0020_Arrow_x0020_Connector_x0020_14" o:spid="_x0000_s2062"
   type="#_x0000_t75" style='position:absolute;margin-left:192pt;margin-top:426.75pt;
   width:36.75pt;height:9.75pt;z-index:14;visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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=
">
   <v:imagedata src="image013.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Elbow_x0020_Connector_x0020_21" o:spid="_x0000_s2063"
   type="#_x0000_t75" style='position:absolute;margin-left:261.75pt;
   margin-top:431.25pt;width:63.75pt;height:130.5pt;z-index:15;visibility:visible'
   o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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=
">
   <v:imagedata src="image014.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Diamond_x0020_16" o:spid="_x0000_s2064" type="#_x0000_t75"
   style='position:absolute;margin-left:222pt;margin-top:670.5pt;width:45pt;
   height:26.25pt;z-index:16;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image015.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Elbow_x0020_Connector_x0020_32" o:spid="_x0000_s2065"
   type="#_x0000_t75" style='position:absolute;margin-left:265.5pt;
   margin-top:573pt;width:60pt;height:111pt;z-index:17;visibility:visible'
   o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image016.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Rectangle_x0020_18" o:spid="_x0000_s2066" type="#_x0000_t75"
   style='position:absolute;margin-left:9.75pt;margin-top:1017pt;width:38.25pt;
   height:21.75pt;z-index:18;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image004.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
   </x:ClientData>
  </v:shape><v:shape id="Rectangle_x0020_19" o:spid="_x0000_s2067" type="#_x0000_t75"
   style='position:absolute;margin-left:301.5pt;margin-top:1062pt;width:39pt;
   height:21pt;z-index:19;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image007.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Straight_x0020_Arrow_x0020_Connector_x0020_20" o:spid="_x0000_s2068"
   type="#_x0000_t75" style='position:absolute;margin-left:315.75pt;
   margin-top:1082.25pt;width:9.75pt;height:28.5pt;z-index:20;visibility:visible'
   o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image017.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Rounded_x0020_Rectangle_x0020_21" o:spid="_x0000_s2069"
   type="#_x0000_t75" style='position:absolute;margin-left:368.25pt;
   margin-top:1149pt;width:51.75pt;height:25.5pt;z-index:21;visibility:visible;
   mso-wrap-style:square;v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image018.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Shape_x0020_22" o:spid="_x0000_s2070" type="#_x0000_t75"
   style='position:absolute;margin-left:263.25pt;margin-top:744.75pt;width:61.5pt;
   height:81pt;z-index:22;visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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=
">
   <v:imagedata src="image019.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Shape_x0020_23" o:spid="_x0000_s2071" type="#_x0000_t75"
   style='position:absolute;margin-left:28.5pt;margin-top:1038pt;width:278.25pt;
   height:39pt;z-index:23;visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image020.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Rectangle_x0020_24" o:spid="_x0000_s2072" type="#_x0000_t75"
   style='position:absolute;margin-left:300pt;margin-top:819.75pt;width:39pt;
   height:21.75pt;z-index:24;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image021.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Diamond_x0020_25" o:spid="_x0000_s2073" type="#_x0000_t75"
   style='position:absolute;margin-left:218.25pt;margin-top:893.25pt;width:45.75pt;
   height:26.25pt;z-index:25;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image022.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Diamond_x0020_26" o:spid="_x0000_s2074" type="#_x0000_t75"
   style='position:absolute;margin-left:150pt;margin-top:893.25pt;width:45pt;
   height:26.25pt;z-index:26;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image023.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Shape_x0020_27" o:spid="_x0000_s2075" type="#_x0000_t75"
   style='position:absolute;margin-left:236.25pt;margin-top:830.25pt;width:64.5pt;
   height:68.25pt;z-index:27;visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image024.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Shape_x0020_28" o:spid="_x0000_s2076" type="#_x0000_t75"
   style='position:absolute;margin-left:263.25pt;margin-top:836.25pt;width:61.5pt;
   height:70.5pt;z-index:28;visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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=
">
   <v:imagedata src="image025.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Straight_x0020_Arrow_x0020_Connector_x0020_29" o:spid="_x0000_s2077"
   type="#_x0000_t75" style='position:absolute;margin-left:189.75pt;
   margin-top:901.5pt;width:29.25pt;height:9.75pt;z-index:29;visibility:visible'
   o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH
7ya+A+FqWqoHY0zpHqwe1Zj1AQhMW2I7EAbr7ts73e5ejGviEeb/8RuoN7tpFDMk8gG1vC4rKQBt
cB57Ld+3T8WdFJQNOjMGBC33QHLTXF7U230EEuxG0nLIOd4rRXaAyVAZIiBPupAmk/mYehWN/TA9
qJuqulU2YAbMRV4yZFO30JnPMYvHHV+vJAlGkuJhFS5dWpoYR29NZlI1o/vRUhwbSnYeNDT4SFeM
IdWvDcvkfMHR98JPk7wD8WpSfjYTYyiXaNkAweaQWFf+nbSgTlSErvMWyjYRL7V6T3DnSlz4wgTz
f/Nbtr3BfEpXh59qvgEAAP//AwBQSwMEFAAGAAgAAAAhAJYFM1jUAAAAlwEAAAsAAABfcmVscy8u
cmVsc6SQPWsDMQyG90L/g9He8yVDKSW+bIWsIYWuxtZ9kLNkJHNN/n1MoaVXsnWUXvQ8L9rtL2k2
C4pOTA42TQsGKXCcaHDwfnp7egGjxVP0MxM6uKLCvnt82B1x9qUe6ThlNZVC6mAsJb9aq2HE5LXh
jFSTniX5UkcZbPbh7Ae027Z9tvKbAd2KaQ7RgRziFszpmqv5DztNQVi5L03gZLnvp3CPaiN/0hGX
SvEyYHEQRb+WgktTy4G979380xuYCENh+aiOlfwnqfbvBnb1zu4GAAD//wMAUEsDBBQABgAIAAAA
IQDSvJEtNgIAAKgGAAAUAAAAZHJzL2Nvbm5lY3RvcnhtbC54bWy8VduOmzAQfa/Uf7D83gUSAgQF
Vqts25dqu9ptP8ACO6AaG9lWQv6+40tAilSpaqLygpmxz5mZMx52j9PA0ZEq3UtR4eQhxoiKRra9
OFT4548vnwqMtCGiJVwKWuEz1fix/vhhN7WqJKLppEIAIXQJhgp3xoxlFOmmowPRD3KkArxMqoEY
+FSHqFXkBOADj1ZxnEV6VJS0uqPUPHsPrh22Ock95fzJUXgTU3Lwq0byOt1FNga7dAdg8Z2xOs/y
NF181uTcSp7qZOPP2PXFaDekxbbY5LPPnXHgC6ORM0sdUK6ZkzjN82yO6u+Yt0maLlEtzDPfJN5H
NJBGyQqH0ojj3lpfVQjp5fiqUN9WeA3qCTKATO9Gkf7QGfSkIFm0l0LQxoBWqy2O5mMzDCm1gY+g
JPkHHQfSC+yCWGX2PUEzWSZSUtHeDToP0GsL7eV/WYrhDFfF0a5MpJyYGm5OT0kDacVFbB8Qg5SS
MQSpplmaJskWozP4V1mRQDuF7CeDGtixjouiWGHU2B2bonAJ+LAszqi0+Url7SFaoArrIP+se+Ki
Jcdv2tjKLYSWnN8svEUxpOefRYvMeYQGJLbvQpJcBLG8GPbWanPm1HO/USihmyC39J3rNwvoRg/d
c4WOhFe4/eXaEDLmApjsDtZzfjdS3wZ/JA1clpYyBlfwfxHPbC5jKe5HPPRCKtdOV1mb6VJq5vku
qnut/XW1gyvMH95TYZ6JIZe7fDXy3QH/i6l/AwAA//8DAFBLAwQUAAYACAAAACEAMjDVVRUBAACM
AQAADwAAAGRycy9kb3ducmV2LnhtbFxQXUvDQBB8F/wPxwq+2Uti0pbaSymCoAiFVkF8O5PNB+bu
4t21if56N9YS8XFmZ2Znd7nqVcMOaF1ttIBwEgBDnZm81qWA56e7qzkw56XOZWM0CvhEB6v0/Gwp
F7np9BYPO18yCtFuIQVU3rcLzl1WoZJuYlrUNCuMVdITtCXPrewoXDU8CoIpV7LWtKGSLd5WmL3v
9kpA176Gpv3ALtabB6X2xeOLVW9CXF706xtgHns/in/d97mAa2pPt9AdkFLBvlnrrDKWFVt09Re1
P/KFNYpZ0xFOgGWmERDDQGyKwqEnFM2n0XF0omZBPE8C4EOuN//cJP3jTpIoJukQfHKHQTybJYOb
j7V+wPjE9BsAAP//AwBQSwECLQAUAAYACAAAACEA/iXrpQABAADqAQAAEwAAAAAAAAAAAAAAAAAA
AAAAW0NvbnRlbnRfVHlwZXNdLnhtbFBLAQItABQABgAIAAAAIQCWBTNY1AAAAJcBAAALAAAAAAAA
AAAAAAAAADEBAABfcmVscy8ucmVsc1BLAQItABQABgAIAAAAIQDSvJEtNgIAAKgGAAAUAAAAAAAA
AAAAAAAAAC4CAABkcnMvY29ubmVjdG9yeG1sLnhtbFBLAQItABQABgAIAAAAIQAyMNVVFQEAAIwB
AAAPAAAAAAAAAAAAAAAAAJYEAABkcnMvZG93bnJldi54bWxQSwUGAAAAAAQABAD5AAAA2AUAAAAA
">
   <v:imagedata src="image026.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Rectangle_x0020_30" o:spid="_x0000_s2078" type="#_x0000_t75"
   style='position:absolute;margin-left:90.75pt;margin-top:967.5pt;width:38.25pt;
   height:20.25pt;z-index:30;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image027.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Rectangle_x0020_31" o:spid="_x0000_s2079" type="#_x0000_t75"
   style='position:absolute;margin-left:301.5pt;margin-top:1105.5pt;width:38.25pt;
   height:21pt;z-index:31;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image007.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Shape_x0020_32" o:spid="_x0000_s2080" type="#_x0000_t75"
   style='position:absolute;margin-left:339pt;margin-top:1116pt;width:60pt;
   height:38.25pt;z-index:32;visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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==
">
   <v:imagedata src="image028.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Shape_x0020_33" o:spid="_x0000_s2081" type="#_x0000_t75"
   style='position:absolute;margin-left:105pt;margin-top:906pt;width:45.75pt;
   height:67.5pt;z-index:33;visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image029.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Shape_x0020_34" o:spid="_x0000_s2082" type="#_x0000_t75"
   style='position:absolute;margin-left:24pt;margin-top:977.25pt;width:66.75pt;
   height:45pt;z-index:34;visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image030.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Rounded_x0020_Rectangle_x0020_35" o:spid="_x0000_s2083"
   type="#_x0000_t75" style='position:absolute;margin-left:369.75pt;
   margin-top:30pt;width:52.5pt;height:25.5pt;z-index:35;visibility:visible;
   mso-wrap-style:square;v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image031.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:group id="Group_x0020_36" o:spid="_x0000_s2084" style='position:absolute;
   margin-left:173.25pt;margin-top:916.5pt;width:68.25pt;height:21pt;z-index:36'
   coordorigin="53863,56673" coordsize="7667,2667">
   <o:lock v:ext="edit" text="t"/>
   <v:shape id="Shape_x0020_37" o:spid="_x0000_s2086" type="#_x0000_t75"
    style='position:absolute;left:53881;top:56949;width:7747;height:2499;
    visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
    <v:imagedata src="image032.png" o:title=""/>
    <o:lock v:ext="edit" aspectratio="f"/>
    <x:ClientData ObjectType="Pict">
     <x:CF>Bitmap</x:CF>
     <x:AutoPict/>
    </x:ClientData>
   </v:shape><v:shape id="Straight_x0020_Arrow_x0020_Connector_x0020_38"
    o:spid="_x0000_s2087" type="#_x0000_t75" style='position:absolute;left:60928;
    top:56034;width:1130;height:3353;visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
    <v:imagedata src="image033.png" o:title=""/>
    <o:lock v:ext="edit" aspectratio="f"/>
    <x:ClientData ObjectType="Pict">
     <x:CF>Bitmap</x:CF>
     <x:AutoPict/>
    </x:ClientData>
   </v:shape></v:group><v:shape id="Rounded_x0020_Rectangle_x0020_39" o:spid="_x0000_s2085"
   type="#_x0000_t75" style='position:absolute;margin-left:369.75pt;
   margin-top:30pt;width:52.5pt;height:25.5pt;z-index:37;visibility:visible;
   mso-wrap-style:square;v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image031.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><![endif]--><span style='mso-ignore:vglayout;
  position:absolute;z-index:1;margin-left:13px;margin-top:40px;width:550px;
  height:1526px'><img width=550 height=1526 src=/img/image034.png v:shapes="Rectangle_x0020_1 Straight_x0020_Arrow_x0020_Connector_x0020_2 Diamond_x0020_3 Rectangle_x0020_4 Shape_x0020_5 Shape_x0020_6 Shape_x0020_7 Rectangle_x0020_8 Rectangle_x0020_9 Rectangle_x0020_10 Straight_x0020_Arrow_x0020_Connector_x0020_11 Elbow_x0020_Connector_x0020_13 Rectangle_x0020_13 Straight_x0020_Arrow_x0020_Connector_x0020_14 Elbow_x0020_Connector_x0020_21 Diamond_x0020_16 Elbow_x0020_Connector_x0020_32 Rectangle_x0020_18 Rectangle_x0020_19 Straight_x0020_Arrow_x0020_Connector_x0020_20 Rounded_x0020_Rectangle_x0020_21 Shape_x0020_22 Shape_x0020_23 Rectangle_x0020_24 Diamond_x0020_25 Diamond_x0020_26 Shape_x0020_27 Shape_x0020_28 Straight_x0020_Arrow_x0020_Connector_x0020_29 Rectangle_x0020_30 Rectangle_x0020_31 Shape_x0020_32 Shape_x0020_33 Shape_x0020_34 Rounded_x0020_Rectangle_x0020_35 Group_x0020_36 Shape_x0020_37 Straight_x0020_Arrow_x0020_Connector_x0020_38 Rounded_x0020_Rectangle_x0020_39"></span><span
  style='mso-ignore:vglayout2'>
  <table cellpadding=0 cellspacing=0>
   <tr>
    <td height=162 class=xl106 width=90 style='height:121.5pt;border-top:none;
    border-left:none;width:68pt'>&nbsp;</td>
   </tr>
  </table>
  </span></td>
  <td class=xl106 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl106 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl106 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl107 style='border-top:none;border-left:none'>Ya</td>
  <td class=xl106 style='border-top:none;border-left:none'>&nbsp;</td>
  <td rowspan=2 class=xl145 width=178 style='border-bottom:.5pt solid black;
  border-top:none;width:134pt'>Fotokopi sertifikat / SKT, KTP, kartu keluarga,
  dan foto lengkap objek pajak.</td>
  <td rowspan=2 class=xl108 style='border-bottom:.5pt solid black;border-top:
  none'>Seketika</td>
  <td class=xl145 width=136 style='border-top:none;border-left:none;width:102pt'>Formulir
  permohonan Pendaftaran Objek Baru dan Bukti Penerimaan Surat.</td>
  <td class=xl110 width=119 style='border-top:none;border-left:none;width:89pt'>&nbsp;</td>
 </tr>
 <tr height=49 style='mso-height-source:userset;height:36.75pt'>
  <td height=49 class=xl111 style='height:36.75pt;border-left:none'>&nbsp;</td>
  <td class=xl111 style='border-left:none'>&nbsp;</td>
  <td class=xl111 style='border-left:none'>&nbsp;</td>
  <td class=xl111 style='border-left:none'>&nbsp;</td>
  <td class=xl112 style='border-left:none'>&nbsp;</td>
  <td class=xl111 style='border-left:none'>&nbsp;</td>
  <td class=xl113 width=136 style='border-left:none;width:102pt'>Disposisi</td>
  <td class=xl114 width=119 style='border-left:none;width:89pt'>&nbsp;</td>
 </tr>
 <tr height=130 style='mso-height-source:userset;height:97.5pt'>
  <td height=130 class=xl115 style='height:97.5pt;border-top:none'>2</td>
  <td class=xl116 width=196 style='border-top:none;border-left:none;width:147pt'>Menerima
  ,meneliti kelengkapan berkas permohonan dan mengagendakan</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl118 style='border-top:none;border-left:none'>Tidak</td>
  <td class=xl119 width=178 style='border-top:none;border-left:none;width:134pt'>Formulir
  permohonan Pendaftaran Objek Baru dan berkas permohonan</td>
  <td class=xl120 width=83 style='border-top:none;border-left:none;width:62pt'>15
  menit</td>
  <td class=xl119 width=136 style='border-top:none;border-left:none;width:102pt'>Formulir
  permohonan Pendaftaran Objek Baru dan Lembar Pengawasan Arus Dokumen (LPAD)</td>
  <td class=xl119 width=119 style='border-top:none;border-left:none;width:89pt'>JFU
  Pelayanan Pos PBB<br>
    Apabila tidak lengkap maka dikembalikan untuk dilengkapi</td>
 </tr>
 <tr height=102 style='height:76.5pt'>
  <td height=102 class=xl115 style='height:76.5pt;border-top:none'>3</td>
  <td class=xl116 width=196 style='border-top:none;border-left:none;width:147pt'>Mengirim
  berkas permohonan ke <font class="font22">back office</font></td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl118 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl119 width=178 style='border-top:none;border-left:none;width:134pt'>Formulir
  permohonan Pendaftaran Objek Baru dan berkas permohonan<br>
    Buku Ekspedisi</td>
  <td class=xl120 width=83 style='border-top:none;border-left:none;width:62pt'>30
  menit</td>
  <td class=xl119 width=136 style='border-top:none;border-left:none;width:102pt'>Formulir
  permohonan Pendaftaran Objek Baru dan Lembar Pengawasan Arus Dokumen (LPAD)</td>
  <td class=xl119 width=119 style='border-top:none;border-left:none;width:89pt'>JFU
  Pelayanan Pos PBB</td>
 </tr>
 <tr height=102 style='height:76.5pt'>
  <td height=102 class=xl115 style='height:76.5pt;border-top:none'>4</td>
  <td class=xl116 width=196 style='border-top:none;border-left:none;width:147pt'>Menerima
  dan mengagendakan berkas permohonan</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl118 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl119 width=178 style='border-top:none;border-left:none;width:134pt'>Formulir
  permohonan Pendaftaran Objek Baru dan berkas permohonan<br>
    Buku Agenda</td>
  <td class=xl120 width=83 style='border-top:none;border-left:none;width:62pt'>5
  menit</td>
  <td class=xl119 width=136 style='border-top:none;border-left:none;width:102pt'>Formulir
  permohonan Pendaftaran Objek Baru dan Lembar Pengawasan Arus Dokumen (LPAD)</td>
  <td class=xl119 width=119 style='border-top:none;border-left:none;width:89pt'>JFU
  Administrasi</td>
 </tr>
 <tr height=77 style='mso-height-source:userset;height:57.75pt'>
  <td height=77 class=xl115 style='height:57.75pt;border-top:none'>5</td>
  <td class=xl116 width=196 style='border-top:none;border-left:none;width:147pt'>Mendisposisi
  berkas permohonan untuk dilakukan penelitian</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl118 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl119 width=178 style='border-top:none;border-left:none;width:134pt'>Formulir
  permohonan Pendaftaran Objek Baru dan berkas permohonan</td>
  <td class=xl120 width=83 style='border-top:none;border-left:none;width:62pt'>10
  menit</td>
  <td class=xl119 width=136 style='border-top:none;border-left:none;width:102pt'>Disposisi</td>
  <td class=xl119 width=119 style='border-top:none;border-left:none;width:89pt'>&nbsp;</td>
 </tr>
 <tr height=246 style='mso-height-source:userset;height:184.5pt'>
  <td height=246 class=xl115 style='height:184.5pt;border-top:none'>6</td>
  <td class=xl116 width=196 style='border-top:none;border-left:none;width:147pt'>Melakukan
  verifikasi berkas permohonan, membuat dan menandatangani konsep Uraian
  Penelitian</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl118 style='border-top:none;border-left:none'>Ya</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl119 width=178 style='border-top:none;border-left:none;width:134pt'>Formulir
  permohonan Pendaftaran Objek Baru, LPAD beserta kelengkapannya</td>
  <td class=xl120 width=83 style='border-top:none;border-left:none;width:62pt'>30
  menit</td>
  <td class=xl119 width=136 style='border-top:none;border-left:none;width:102pt'>Konsep
  Uraian Penelitian</td>
  <td class=xl119 width=119 style='border-top:none;border-left:none;width:89pt'>-
  JFU Administrasi melaksanakan penelitian lapangan apabila diperlukan</td>
 </tr>
 <tr height=89 style='mso-height-source:userset;height:66.75pt'>
  <td height=89 class=xl115 style='height:66.75pt;border-top:none'>7</td>
  <td class=xl116 width=196 style='border-top:none;border-left:none;width:147pt'>Meneliti
  dan menandatangani konsep Uraian Penelitian</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl118 style='border-top:none;border-left:none'>Tidak</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl119 width=178 style='border-top:none;border-left:none;width:134pt'>Konsep
  Uraian Penelitian</td>
  <td class=xl120 width=83 style='border-top:none;border-left:none;width:62pt'>20
  menit</td>
  <td class=xl119 width=136 style='border-top:none;border-left:none;width:102pt'>Uraian
  Penelitian</td>
  <td class=xl119 width=119 style='border-top:none;border-left:none;width:89pt'>&nbsp;</td>
 </tr>
 <tr height=90 style='mso-height-source:userset;height:67.5pt'>
  <td height=90 class=xl115 style='height:67.5pt;border-top:none'>8</td>
  <td class=xl116 width=196 style='border-top:none;border-left:none;width:147pt'>Mendisposisi
  ke IT untuk dilakukan perekaman SPOP dan pencetakan SPPT</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl119 width=178 style='border-top:none;border-left:none;width:134pt'>Uraian
  Penelitian<br>
    Formulir permohonan Pendaftaran Objek Baru, BPS, LPAD beserta
  kelengkapannya</td>
  <td class=xl120 width=83 style='border-top:none;border-left:none;width:62pt'>15
  menit</td>
  <td class=xl119 width=136 style='border-top:none;border-left:none;width:102pt'>Disposisi</td>
  <td class=xl119 width=119 style='border-top:none;border-left:none;width:89pt'>&nbsp;</td>
 </tr>
 <tr height=110 style='mso-height-source:userset;height:82.5pt'>
  <td height=110 class=xl115 style='height:82.5pt;border-top:none'>9</td>
  <td class=xl116 width=196 style='border-top:none;border-left:none;width:147pt'>Melaksanakan
  perekaman SPOP, LSPOP dan mencetak konsep SPPT<span
  style='mso-spacerun:yes'>�</span></td>
  <td class=xl121 width=90 style='border-top:none;border-left:none;width:68pt'>&nbsp;</td>
  <td class=xl121 width=89 style='border-top:none;border-left:none;width:67pt'>&nbsp;</td>
  <td class=xl121 width=102 style='border-top:none;border-left:none;width:77pt'>&nbsp;</td>
  <td class=xl122 width=88 style='border-top:none;border-left:none;width:66pt'>Ya</td>
  <td class=xl122 width=106 style='border-top:none;border-left:none;width:80pt'>&nbsp;</td>
  <td class=xl121 width=105 style='border-top:none;border-left:none;width:79pt'>&nbsp;</td>
  <td class=xl119 width=178 style='border-top:none;border-left:none;width:134pt'>Disposisi<br>
    Uraian Penelitian<br>
    Formulir permohonan Pendaftaran Objek Baru, LPAD beserta kelengkapannya</td>
  <td class=xl123 style='border-top:none;border-left:none'>10 menit</td>
  <td class=xl119 width=136 style='border-top:none;border-left:none;width:102pt'>Konsep
  SPPT</td>
  <td class=xl119 width=119 style='border-top:none;border-left:none;width:89pt'>JFU
  IT</td>
 </tr>
 <tr height=119 style='mso-height-source:userset;height:89.25pt'>
  <td height=119 class=xl115 style='height:89.25pt;border-top:none'>10</td>
  <td class=xl116 width=196 style='border-top:none;border-left:none;width:147pt'>Meneliti
  dan memaraf konsep SPPT</td>
  <td class=xl121 width=90 style='border-top:none;border-left:none;width:68pt'>&nbsp;</td>
  <td class=xl121 width=89 style='border-top:none;border-left:none;width:67pt'>&nbsp;</td>
  <td class=xl124 width=102 style='border-top:none;border-left:none;width:77pt'>Ya</td>
  <td class=xl125 width=88 style='border-top:none;border-left:none;width:66pt'>Tidak</td>
  <td class=xl122 width=106 style='border-top:none;border-left:none;width:80pt'>Tidak</td>
  <td class=xl122 width=105 style='border-top:none;border-left:none;width:79pt'>&nbsp;</td>
  <td class=xl119 width=178 style='border-top:none;border-left:none;width:134pt'>Konsep
  SPPT</td>
  <td class=xl123 style='border-top:none;border-left:none'>10 menit</td>
  <td class=xl119 width=136 style='border-top:none;border-left:none;width:102pt'>Konsep
  SPPT</td>
  <td class=xl119 width=119 style='border-top:none;border-left:none;width:89pt'>Apabila
  tidak sesuai maka dikembalikan untuk diperbaiki</td>
 </tr>
 <tr height=64 style='mso-height-source:userset;height:48.0pt'>
  <td height=64 class=xl115 style='height:48.0pt;border-top:none'>11</td>
  <td class=xl116 width=196 style='border-top:none;border-left:none;width:147pt'>Memeriksa
  dan memaraf konsep SPPT</td>
  <td class=xl121 width=90 style='border-top:none;border-left:none;width:68pt'>&nbsp;</td>
  <td class=xl121 width=89 style='border-top:none;border-left:none;width:67pt'>&nbsp;</td>
  <td class=xl121 width=102 style='border-top:none;border-left:none;width:77pt'>&nbsp;</td>
  <td class=xl121 width=88 style='border-top:none;border-left:none;width:66pt'>&nbsp;</td>
  <td class=xl121 width=106 style='border-top:none;border-left:none;width:80pt'>&nbsp;</td>
  <td class=xl121 width=105 style='border-top:none;border-left:none;width:79pt'>&nbsp;</td>
  <td class=xl119 width=178 style='border-top:none;border-left:none;width:134pt'>Konsep
  SPPT</td>
  <td class=xl123 style='border-top:none;border-left:none'>5 menit</td>
  <td class=xl119 width=136 style='border-top:none;border-left:none;width:102pt'>Konsep
  SPPT</td>
  <td class=xl119 width=119 style='border-top:none;border-left:none;width:89pt'>&nbsp;</td>
 </tr>
 <tr height=63 style='mso-height-source:userset;height:47.25pt'>
  <td height=63 class=xl115 style='height:47.25pt;border-top:none'>12</td>
  <td class=xl116 width=196 style='border-top:none;border-left:none;width:147pt'>Menandatangani
  konsep SPPT</td>
  <td class=xl121 width=90 style='border-top:none;border-left:none;width:68pt'>&nbsp;</td>
  <td class=xl121 width=89 style='border-top:none;border-left:none;width:67pt'>&nbsp;</td>
  <td class=xl121 width=102 style='border-top:none;border-left:none;width:77pt'>&nbsp;</td>
  <td class=xl121 width=88 style='border-top:none;border-left:none;width:66pt'>&nbsp;</td>
  <td class=xl121 width=106 style='border-top:none;border-left:none;width:80pt'>&nbsp;</td>
  <td class=xl121 width=105 style='border-top:none;border-left:none;width:79pt'>&nbsp;</td>
  <td class=xl119 width=178 style='border-top:none;border-left:none;width:134pt'>Konsep
  SPPT</td>
  <td class=xl123 style='border-top:none;border-left:none'>5 menit</td>
  <td class=xl119 width=136 style='border-top:none;border-left:none;width:102pt'>SPPT</td>
  <td class=xl119 width=119 style='border-top:none;border-left:none;width:89pt'>&nbsp;</td>
 </tr>
 <tr height=59 style='mso-height-source:userset;height:44.25pt'>
  <td height=59 class=xl115 style='height:44.25pt;border-top:none'>13</td>
  <td class=xl116 width=196 style='border-top:none;border-left:none;width:147pt'>Menerima
  dan mengagenda SPPT untuk dikirimkan ke Pos Pelayanan PBB</td>
  <td class=xl121 width=90 style='border-top:none;border-left:none;width:68pt'>&nbsp;</td>
  <td class=xl121 width=89 style='border-top:none;border-left:none;width:67pt'>&nbsp;</td>
  <td class=xl121 width=102 style='border-top:none;border-left:none;width:77pt'>&nbsp;</td>
  <td class=xl121 width=88 style='border-top:none;border-left:none;width:66pt'>&nbsp;</td>
  <td class=xl121 width=106 style='border-top:none;border-left:none;width:80pt'>&nbsp;</td>
  <td class=xl121 width=105 style='border-top:none;border-left:none;width:79pt'>&nbsp;</td>
  <td class=xl119 width=178 style='border-top:none;border-left:none;width:134pt'>SPPT<br>
    Buku Agenda</td>
  <td class=xl123 style='border-top:none;border-left:none'>5 menit</td>
  <td class=xl119 width=136 style='border-top:none;border-left:none;width:102pt'>SPPT</td>
  <td class=xl119 width=119 style='border-top:none;border-left:none;width:89pt'>JFU
  Administrasi</td>
 </tr>
 <tr height=55 style='mso-height-source:userset;height:41.25pt'>
  <td height=55 class=xl115 style='height:41.25pt;border-top:none'>14</td>
  <td class=xl116 width=196 style='border-top:none;border-left:none;width:147pt'>Menerima
  SPPT serta menyampaikan kepada Wajib Pajak<span
  style='mso-spacerun:yes'>�</span></td>
  <td class=xl121 width=90 style='border-top:none;border-left:none;width:68pt'>&nbsp;</td>
  <td class=xl121 width=89 style='border-top:none;border-left:none;width:67pt'>&nbsp;</td>
  <td class=xl121 width=102 style='border-top:none;border-left:none;width:77pt'>&nbsp;</td>
  <td class=xl121 width=88 style='border-top:none;border-left:none;width:66pt'>&nbsp;</td>
  <td class=xl121 width=106 style='border-top:none;border-left:none;width:80pt'>&nbsp;</td>
  <td class=xl121 width=105 style='border-top:none;border-left:none;width:79pt'>&nbsp;</td>
  <td class=xl119 width=178 style='border-top:none;border-left:none;width:134pt'>SPPT</td>
  <td class=xl123 style='border-top:none;border-left:none'>5 menit</td>
  <td class=xl119 width=136 style='border-top:none;border-left:none;width:102pt'>SPPT<br>
    </td>
  <td class=xl119 width=119 style='border-top:none;border-left:none;width:89pt'>JFU
  Pos Pelayanan PBB</td>
 </tr>
 <tr height=60 style='mso-height-source:userset;height:45.0pt'>
  <td height=60 class=xl115 style='height:45.0pt;border-top:none'>15</td>
  <td class=xl116 width=196 style='border-top:none;border-left:none;width:147pt'>Menerima
  SPPT</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl117 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl119 width=178 style='border-top:none;border-left:none;width:134pt'>SPPT<br>
    </td>
  <td class=xl120 width=83 style='border-top:none;border-left:none;width:62pt'>seketika</td>
  <td class=xl119 width=136 style='border-top:none;border-left:none;width:102pt'>SPPT<br>
    </td>
  <td class=xl119 width=119 style='border-top:none;border-left:none;width:89pt'>&nbsp;</td>
 </tr>
 <tr height=42 style='mso-height-source:userset;height:31.5pt'>
  <td height=42 class=xl126 style='height:31.5pt'></td>
  <td class=xl126></td>
  <td class=xl126></td>
  <td class=xl126></td>
  <td class=xl126></td>
  <td class=xl126></td>
  <td class=xl126></td>
  <td class=xl126></td>
  <td class=xl126></td>
  <td class=xl126></td>
  <td class=xl126></td>
  <td class=xl127></td>
 </tr>
 <tr height=20 style='height:15.0pt'>
  <td height=20 class=xl126 style='height:15.0pt'></td>
  <td class=xl126></td>
  <td class=xl126></td>
  <td class=xl126></td>
  <td class=xl126></td>
  <td class=xl126></td>
  <td class=xl126></td>
  <td class=xl126></td>
  <td class=xl104></td>
  <td class=xl128></td>
  <td class=xl126></td>
  <td class=xl126></td>
 </tr>
 <tr height=20 style='height:15.0pt'>
  <td height=20 class=xl126 style='height:15.0pt'></td>
  <td class=xl126></td>
  <td class=xl126></td>
  <td class=xl126></td>
  <td class=xl126></td>
  <td class=xl126></td>
  <td class=xl126></td>
  <td class=xl126></td>
  <td class=xl104></td>
  <td class=xl128></td>
  <td class=xl129></td>
  <td class=xl129></td>
 </tr>
 <tr height=20 style='height:15.0pt'>
  <td height=20 class=xl126 style='height:15.0pt'></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl128></td>
  <td class=xl130></td>
  <td class=xl130></td>
 </tr>
 <tr height=20 style='height:15.0pt'>
  <td height=20 class=xl104 style='height:15.0pt'></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl131></td>
  <td class=xl104></td>
  <td class=xl104></td>
 </tr>
 <tr height=20 style='height:15.0pt'>
  <td height=20 class=xl104 style='height:15.0pt'></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl131></td>
  <td class=xl104></td>
  <td class=xl104></td>
 </tr>
 <tr height=20 style='height:15.0pt'>
  <td height=20 class=xl104 style='height:15.0pt'></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl132></td>
  <td class=xl104></td>
  <td class=xl104></td>
 </tr>
 <tr height=20 style='height:15.0pt'>
  <td height=20 class=xl104 style='height:15.0pt'></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl128></td>
  <td class=xl104></td>
  <td class=xl104></td>
 </tr>
 <tr height=20 style='height:15.0pt'>
  <td height=20 class=xl104 style='height:15.0pt'></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl104></td>
  <td class=xl128></td>
  <td class=xl104></td>
  <td class=xl104></td>
 </tr>
 <tr height=0 style='display:none'>
  <td width=32 style='width:24pt'></td>
  <td width=196 style='width:147pt'></td>
  <td width=90 style='width:68pt'></td>
  <td width=89 style='width:67pt'></td>
  <td width=102 style='width:77pt'></td>
  <td width=88 style='width:66pt'></td>
  <td width=106 style='width:80pt'></td>
  <td width=105 style='width:79pt'></td>
  <td width=178 style='width:134pt'></td>
  <td width=83 style='width:62pt'></td>
  <td width=136 style='width:102pt'></td>
  <td width=119 style='width:89pt'></td>
 </tr>
</table>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  components: {
    Modal,
    PulseLoader,
  },
  data() {
    return {
      modals: {
        modal1: false,
      },
      htmls: null,
      isBusy: false,
    };
  },
  methods: {
    showModal() {
      this.modals.modal1 = true;
    },
    hideModal() {
      this.modals.modal1 = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-dialog {
  max-width: 1000px;
  margin: 1.75rem auto;
}

</style>